<template>
    <CDropdown inNav
               class="c-header-nav-items"
               placement="bottom-end"
               add-menu-classes="pt-0">
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img src="../../assets/icons/gear-solid.svg"
                         class="c-avatar-img " width="23" />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div"
                         class="text-center rounded-top"
                         color="light"
                         style="margin-top: -1px;">
            <strong>{{ getLanguage["HEA"]["AC"] }}</strong>
        </CDropdownHeader>
        <router-link to="/Profile" tag="a" class="dropdown-item">
            <i class="c-icon cil-user"></i>{{ getLanguage["HEA"]["PF"] }}
        </router-link>
        <CDropdownDivider class="my-0" />
        <CDropdownItem @click="btnClick('Simple')">
            <i class="fas fa-sync mr-2"></i>
            <template v-if="this.$parent.$parent.$parent.$parent.isSimpleMode">
                {{getLanguage["AG"]["NORM"]}}
            </template>
            <template v-else>
                {{getLanguage["AG"]["SIMM"]}}
            </template>
        </CDropdownItem>
        <CDropdownDivider class="my-0" />
        <CDropdownItem @click="btnClick('Logout')">
            <CIcon name="cil-lock-locked" /> {{ getLanguage["HEA"]["L"] }}
        </CDropdownItem>
    </CDropdown>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        computed:{
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('DashboardData', [
            'getPendingDeposit',
            'getPendingWithdrawal',
            'getPendingPromotion'
            ]),
        },
        methods: {
            btnClick(path) {
                if (path == "Deposit") {
                    this.$router.push("/D/DDU");
                } else if (path == "Withdraw") {
                    this.$router.push("/W/WDU");
                } else if (path == "Promotion") {
                    this.$router.push("/P/PDU");
                } else if (path == "Member") {
                    this.$router.push("/M/MO");
                } else if (path == "Logout") {
                    localStorage.setItem('isMute', 'False');
                    window.location.href = "/auth/logout";
                } else if (path == "Simple") {
                    //this.$parent.$parent.$parent.$parent.bool_fullpageLoading = true;
                    if (this.$parent.$parent.$parent.$parent.isSimpleMode) {
                        this.$parent.$parent.$parent.$parent.isSimpleMode = false;
                    } else {
                        this.$parent.$parent.$parent.$parent.isSimpleMode = true;
                    }
                }
            },
            renderPendingStyle(menuTitle){
                if(menuTitle == 'D'){
                    return { 'background-color': '#057b00', 'color': '#ffffff' };
                }else if(menuTitle == 'W'){
                    return { 'background-color': '#d40000', 'color': '#ffffff' };
                }else if(menuTitle == 'P'){
                    return { 'background-color': '#7800b6', 'color': '#ffffff' };
                }
            },
        },
    }
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderDropdown/HeaderDropdownAccnt.vue